import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'k3Sanbutong'
})
export class K3SanbutongPipe implements PipeTransform {

  transform(value: any): any {
    let str: string;
    let arr = Array.from(new Set(value));

    if (arr.length === 3) {
      str = '三不同';
    } else {
      str = '--';
    }

    return str;
  }

}
